import ContactUs from '../Page/ContactUs';

export default ContactUs;
